import {
  START_FETCH_CERTIFICATES_PAGE_DATA,
  SUCCESS_FETCH_CERTIFICATES_PAGE_DATA,
  ERROR_FETCH_CERTIFICATES_PAGE_DATA,
} from "./../actions/certificatesPageActionsTypes";

const initialState = {
  isLoading: false,
  certificatesPageData: [],
  errorFetchingCertificatesPageData: "",
};

const CertificatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_FETCH_CERTIFICATES_PAGE_DATA:
      return {
        ...state,
        isLoading: true,
      };
    case SUCCESS_FETCH_CERTIFICATES_PAGE_DATA:
      return {
        ...state,
        isLoading: false,
        certificatesPageData: action.certificatesPageData,
        errorFetchingCertificatesPageData: "",
      };
    case ERROR_FETCH_CERTIFICATES_PAGE_DATA:
      return {
        ...state,
        isLoading: false,
        errorFetchingCertificatesPageData: action.error,
      };
    default:
      return state;
  }
};
export default CertificatesReducer;
